import { Box, styled } from "@mui/system";


export const PortalContent = styled(Box)(() => ({
  flexShrink: 1,
  padding: "30px",
  overflowY: "auto"
}))